
import { CreatePhysicalToolBehavior2 } from '../../canvas/tooling/CreatePhysicalToolBehavior2';
import { defineToolWithCommonBehaviors } from '../../canvas/tooling/Definitions';
import { Jukebox } from './Jukebox';

class CreateJukeboxToolBehavior extends CreatePhysicalToolBehavior2(Jukebox, 'plop') {
}

export const jukeboxTool = defineToolWithCommonBehaviors({
    id: 'jukeboxTool',
    label: 'Jukebox',
    category: 'objects',
    behaviors: [
        CreateJukeboxToolBehavior,
    ]
});
